import axiosRequest from "api";
import { payloadHelper } from "helpers/payload-helper";
import {
  DepositOfflineSubmissionFormNews,
  DepositOnlineSubmission,
} from "types/deposit";

import {
  DepositFormSettingResponse,
  DepositOfflineSubmissionForm,
  DepositOnlineSubmissionForm,
  DepositResponse,
  DepositSubmissionFormType,
} from "./type";

export const DepositApi = {
  getDepositForm: (username: string) =>
    axiosRequest.post<DepositFormSettingResponse>(
      "",
      payloadHelper("DepositForm", username, {
        username,
      })
    ),
  OnlineDepositSubmission: (
    typename: string,
    payload: DepositOnlineSubmissionForm
  ) =>
    axiosRequest.post<any>(
      "/",
      payloadHelper("GatewayDeposit", typename, payload)
    ),
  depositSubmission: (
    typename: string,
    payload:
      | DepositOnlineSubmissionForm
      | DepositOfflineSubmissionForm
      | DepositSubmissionFormType
  ) =>
    axiosRequest.post<DepositResponse>(
      "/",
      payloadHelper("Deposit", typename, payload)
    ),
  depositSubmissionOffline: (
    typename: string,
    payload: DepositOfflineSubmissionFormNews
  ) =>
    axiosRequest.post<DepositResponse>(
      "/",
      payloadHelper("Deposit", typename, payload)
    ),

  depositSubmissionOnline: (
    typename: string,
    payload: DepositOnlineSubmission
  ) =>
    axiosRequest.post<DepositResponse>(
      "/",
      payloadHelper("GatewayDeposit", typename, payload)
    ),
};
